/**
 * Created by lihanying on 2017/7/6.
 */
import { GETADDCLUBINFO } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETADDCLUBINFO:
      return Object.assign({}, state, { clubInfo: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubAdd/reduce.js